var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vast-service-order-now-apply-button"},[_c('OBtn',_vm._g({},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.locale.save)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }